import { render, staticRenderFns } from "./apichannelreport.vue?vue&type=template&id=5064f5f8&"
import script from "./apichannelreport.vue?vue&type=script&lang=js&"
export * from "./apichannelreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports